// -*- coding: utf-8 -*-
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Skeleton from '@mui/material/Skeleton';
import TextField from '@mui/material/TextField';

export default function ClassSelector({
  classes,
  value,
  onChange,
  loading,
  disabled,
  size = 'small',
  sx,
  minWidth = 240,
}) {
  return (
    <Autocomplete
      size={size}
      sx={{ minWidth, ...sx }}
      options={[...classes]}
      getOptionLabel={(opt) => typeof opt === 'string' ? opt : (opt?.name || '')}
      value={classes.find(c => (typeof c === 'object' ? c.name : c) === value) || null}
      onChange={(_, v) => {
        const val = v ? (typeof v === 'object' ? v.name : v) : '';
        onChange(val);
      }}
      loading={loading}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Şube"
          placeholder="Seç / yaz"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <Skeleton variant="circular" width={16} height={16} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      clearOnEscape
    />
  );
}
